import type { ReactElement } from 'react';

import { formatApplicationStatus } from '../../lib/constants';

/**
 * Colour carries meaning here, so it is derived from the status rather than
 * passed in — a caller cannot accidentally paint "fee due" as green.
 *
 * Colour is never the only signal: the label always states the status in words,
 * which is what a screen reader and a colour-blind parent rely on.
 */
type Tone = 'success' | 'pending' | 'info' | 'neutral';

/** Keep in lockstep with the sidebar dots in ParentShell. */
const TONES: Record<string, Tone> = {
  ADMISSION_CONFIRMED: 'success',
  ADMISSION_PROVISIONAL: 'success',
  PAID: 'success',
  REGISTRATION_PENDING_PAYMENT: 'pending',
  PAYMENT_PENDING: 'pending',
  QUOTATION_ISSUED: 'pending',
  APPROVAL_COMPLETE: 'pending',
  AWAITING_PARENT_DECISION: 'pending',
  CHANGES_REQUESTED: 'pending',
  UNDER_REVIEW: 'info',
  REGISTERED: 'info',
  SUBMITTED: 'info',
  DRAFT: 'neutral',
  REJECTED: 'neutral',
  WITHDRAWN: 'neutral',
};

export function StatusBadge({ status }: { status: string }): ReactElement {
  const tone = TONES[status] ?? 'neutral';
  return (
    <span className={`badge badge-${tone}`}>{formatApplicationStatus(status)}</span>
  );
}
